// extracted by mini-css-extract-plugin
module.exports = {"divider":"VerticalDivider_divider__89BWC"};